import React, { useState } from 'react'
import styled from 'styled-components'
// @ts-ignore
import { Skeleton } from '@netbasequid/core'
import { useInsightContentData } from 'hooks/useInsightModalState'
import InsightContentType from 'components/insightContent/enum/InsightContentType'
import { ServiceResultWith } from 'schemas/ServiceResultSchema'
import { AnnotatedMetricResultWith } from 'schemas/AnnotatedMetricResultSchema'
import { Status } from 'features/types'
import { MediaPostMetric } from 'schemas/MediaPostMetricSchema'
import { Post } from 'schemas/PostSchema'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import DomainIcon from 'components/visualization/MediaModal/DomainIcon'
import { InsightContentSettingType } from '../types'
import RunSearchEffect from './RunSearchEffect'
import Card from './Card'
import Modal from './Modal'
import PhotoDetail from './PhotoDetail'
import DeletedCard from './DeletedCard'

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`

interface MediaProps {
  detailSetting: InsightContentSettingType
  title?: string
}

const retrieveMetrics = (data: ServiceResultWith<AnnotatedMetricResultWith<MediaPostMetric>>[]) =>
  data?.[0]?.results?.[0]?.data?.metrics || []

const Media = ({ detailSetting, title }: MediaProps) => {
  const theme = useDisplayTheme() as Theme
  const [selectedMetric, setSelectedMetric] = useState<MediaPostMetric | undefined>(undefined)
  const selectedPost: Post | undefined = selectedMetric && {
    domain: selectedMetric?.domain,
    postID: selectedMetric?.postId
  }

  const insightContent = useInsightContentData<{
    status: Status
    data: ServiceResultWith<AnnotatedMetricResultWith<MediaPostMetric>>[]
  }>(InsightContentType.PHOTO_CONCEPT)
  const metrics = retrieveMetrics(insightContent?.data)

  const deletedCount = metrics.filter((metric) => metric.deleted).length

  return (
    <>
      <Container>
        <RunSearchEffect detailSetting={detailSetting}>
          {insightContent?.status === 'loading' && (
            <Skeleton
              mode={theme}
              variation="rectangle"
              animation="wave"
              width="100%"
              height="474px"
            />
          )}
          {insightContent?.status === 'succeeded' &&
            metrics.map((metric) => {
              if (metric.deleted) {
                return null
              }
              return (
                <Card
                  key={metric.url}
                  url={metric.url}
                  onClick={() => {
                    setSelectedMetric(metric)
                  }}
                  topLeftIcon={
                    <DomainIcon domain={metric.domain} dataStream={metric.dataStreams?.[0]} />
                  }
                />
              )
            })}
          {Boolean(deletedCount) && <DeletedCard deletedCount={deletedCount} />}
        </RunSearchEffect>
      </Container>
      {selectedPost && (
        <Modal
          title={title}
          open={!!selectedMetric}
          onClose={() => {
            setSelectedMetric(undefined)
          }}>
          <PhotoDetail
            imageUrl={selectedMetric?.url}
            originUrl={selectedMetric?.link}
            detailSetting={detailSetting}
            post={selectedPost}
          />
        </Modal>
      )}
    </>
  )
}

export default Media
